var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{attrs:{"title":"Cadastrar nova ocorrência","active":_vm.active},on:{"update:active":function($event){_vm.active=$event},"close":_vm.closeModal}},[_c('FormOccurrence',{attrs:{"entityId":_vm.entityId,"saveOccurrenceApi":_vm.saveOccurrenceApi},on:{"update":_vm.closeModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }